export default __webpack_public_path__ + "static/media/Martinez.e5df7c6d.jpg";